<template>
    <div id="listing-view">
        <flash-message transitionIn="animated swing"></flash-message>
        <b-row>
            <b-col xs="12" lg="12">
                <b-card>
                    <div slot="header">
                        {{ user.name }} {{ user.surname }}
                    </div>
                    <b-tabs >
                        <b-tab active>
                            <template slot="title">
                                <i class="icon-list"></i> Details
                            </template>
                            <h3>Edit details</h3>
                            <user-form
                              :user="user"
                              :edit-option="true"
                            ></user-form>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
    import {User} from "../../models/User";
    import UserForm from "../../components/users/UserForm";

    export default {
        name: 'user',
        components: {
          UserForm,
        },
        data (){
            return {
                user: new User(),
                userId: this.$route.params.userId,
            }
        },
        created() {
          RepositoryFactory
            .get('user')
            .getUser(this.userId)
            .then(
              response => (
                this.user = response.data.data
              )
            )
        }
    }
</script>
